import React from "react";

const IndiaPromoBanner = ({show}) => {
  if (!show)
    return null

  return <div className="transparent-white-bg round-20 white mb-3 p-2 w-75 me-auto ms-auto">
    🌟 Limited time deal - 70% discount applied! 🌟
  </div>
}

export default IndiaPromoBanner;